import React, { useEffect, useState } from 'react';

import RenderFieldBasedOnType from '../../RenderFieldsBasedOnType';
import {
    Grid,
    Typography
} from '@material-ui/core'
import { Helpers } from "dsilo-ui-components";

import useStyles from './style';

/* For now It is static */
const defaultOptions = {}

const SummaryBlockViewer = (props) => {
    const { formData, selectedStep, blockState, onChange, block, isEditable } = props;
    const [blockHeaders, setBlockHeaders] = useState([]);
    const classes = useStyles();

    useEffect(() => {
        if (formData?.dataModel[selectedStep.dataModel]) {
            let dataElements = formData.dataModel[selectedStep.dataModel].dataElements || [];
            if (dataElements?.length) {
                let fdes = [];
                if (block.config.dataElements) {
                    fdes = JSON.parse(JSON.stringify(block.config.dataElements));
                    fdes = fdes.map(fde => {
                        let sde = dataElements.find(de => de.name === fde.value);
                        if (sde?.name) {
                            return { ...sde, ...fde }
                        } else {
                            return fde
                        }
                    });
                    setBlockHeaders(fdes);
                }
            }
        }
    }, [formData?.dataModel]);

    return (
        <React.Fragment>
            <Grid container spacing={1} className={classes.containerPadding}>
                <Grid item xs={12} className={classes.titleRow}>
                    <Typography className={classes.blockTitle}>
                        {block.title}
                    </Typography>
                </Grid>

                {blockHeaders?.length > 0 && blockHeaders?.map((element, index) => {
                    const isFieldReadOnly = !isEditable || element.readOnly;

                    return (
                        <Grid
                            item
                            key={index}
                            xs={element.xs ? element.xs : 3}
                            className={classes.fieldItem}
                        >
                            <Typography className={classes.fieldLabel}>
                                {element.label}
                            </Typography>

                            <RenderFieldBasedOnType
                                {...props}
                                classes={classes}
                                element={{ ...element, readOnly: isFieldReadOnly }}
                                onChange={onChange}
                                dataObj={blockState}
                                options={defaultOptions[element.value || element.name]}
                                selectedStep={props.selectedStep}
                            />

                            <Typography className={classes.helperText}>
                                {element.helperText}
                            </Typography>
                        </Grid>
                    )
                })}
            </Grid>
        </React.Fragment>
    )
}

export default SummaryBlockViewer;

